import { atom } from 'jotai';
import {
    IChildParentalAuthorityStatus,
    ISelfResponse,
} from '@/shared/interfaces';

// Backing atom that holds the ISelfResponse we get from the server
export const profileAtom = atom<ISelfResponse | null>();

export const childrenParentalAuthorityStatusAtom = atom<
    IChildParentalAuthorityStatus[]
>([]);
